
    const html = "<div ng-switch=datepickerMode> <div uib-daypicker ng-switch-when=day tabindex=0 class=uib-daypicker></div> <div uib-monthpicker ng-switch-when=month tabindex=0 class=uib-monthpicker></div> <div uib-yearpicker ng-switch-when=year tabindex=0 class=uib-yearpicker></div> </div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('uib/template/datepicker/datepicker.html', html);
    }]);
    module.exports = 'uib/template/datepicker/datepicker.html';
  